import React, { useState, useCallback } from "react";
import Button from "../../../../components/Button";
import { useDropzone } from "react-dropzone";

import uploadSingleFile from "./uploadSingleFile";
import { getFilename } from "../../../../../fileUploadUtils";
// @ts-ignore
import setPageClosingBlocker from "../../../../../pageClosingBlocker";
import { useDispatch } from "react-redux";

interface ActionSingleFileProps {
  value?: string;
  label?: string;
  customerId: string;
  siteId: string;
  uploadPath: string;
  onInputSuccess: (value: string) => void;
}

export default function ActionSingleFile({
  value,
  label,
  customerId,
  siteId,
  onInputSuccess,
  uploadPath,
}: ActionSingleFileProps) {
  const [isUploading, setIsUploading] = useState(false);
  const filename = (value && getFilename(value)) || label || "Upload file";
  const dispatch = useDispatch();
  const onDrop = useCallback(
    (files: File[]) => {
      const file = files[0];
      setIsUploading(true);
      const unblockPageClosing = setPageClosingBlocker();
      uploadSingleFile(file, customerId, siteId, uploadPath, dispatch).then(
        (resp) => {
          onInputSuccess(resp);
          setIsUploading(false);
          unblockPageClosing();
        },
        (err) => {
          alert(`Failed to upload file: ${err.message}`);
          setIsUploading(false);
          unblockPageClosing();
          console.log(err); // Flow happy
        },
      );
    },
    [setIsUploading],
  );
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: false,
  });

  if (isUploading) {
    return <div>Uploading..</div>;
  }

  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      <Button
        type={value && getFilename(value) ? "secondary" : "primary"}
        label={filename}
        onClick={() => null}
      />
    </div>
  );
}
